import { useQuery } from 'react-query'
import { axios } from 'lib'
import { toast } from 'react-toastify'

export interface LoadProductStockByMaterialQuery {
  unityId: string
  especif1: string
}

export interface ProductStockByMaterial {
  tipo: string
  cdMaterial: string
  unidadeNegocio: string
  centroArmazenagem: string
  especif1: string
  especif2: string
  especif3: string
  numeracao: string
  lote: string
  quantidade: number
  validade: string | null
  totalGeral: number
}

type Response = {
  data: ProductStockByMaterial[]
}

const loadProductStockByMaterial = (
  productId: string,
  query: LoadProductStockByMaterialQuery
): Promise<Response> => {
  const { unityId, especif1 } = query

  return axios.get(`/orders/products/${productId}/stock-by-material`, {
    params: {
      unityId,
      configuratorId: especif1
    }
  })
}

export function useLoadProductStockByMaterial(
  productId: string,
  query: LoadProductStockByMaterialQuery,
  enabled = true
) {
  return useQuery(
    ['productStockByMaterial', productId, query],
    () => loadProductStockByMaterial(productId, query),
    {
      enabled: enabled && !!productId && !!query.unityId && !!query.especif1,
      onError: () =>
        toast.error('Não foi possível carregar o estoque do produto!', {
          toastId: 'loadProductStockByMaterial'
        })
    }
  )
}
